module.exports = __webpack_public_path__ + "img/nandu4f.e3fdf115.png";